<template>
  <div>
    <model-table
      :collection="payments"
      title="Disputes"
      :columns="columns"
      :sort-by="sortBy"
      :descending="descending"

      :show-add="false"
      :show-edit="false"

      :edit-on-row-click="false"
      @row-clicked="row => handleRowClick(row)"
    >
      <template
        #header-controls
      >
        <div
          v-if="$isPermitted($permissions.Financial.View)"
          class="row q-mt-sm"
        >
          <q-btn-toggle
            v-model="showAllSites"
            size="md"
            class="q-my-xs"
            outline
            dense
            toggle-color="primary"
            options-label-position="left"
            options-label-align="center"
            :options="[
              { label: 'Circuit', value: true },
              { label: 'Site', value: false }
            ]"
          />
        </div>
      </template>
    </model-table>
    <dispute-dialog
      ref="disputeDialog"
      @closed="updateModel"
    />
  </div>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import DisputeDialog from 'src/modules/admin/dispute/DisputeDialog'
import OrderItemTypeCell from 'src/modules/admin/order/components/OrderItemTypeCell'
import PaymentDisputeStateCell from 'src/modules/admin/payment/components/PaymentDisputeStateCell'
import PaymentStateCell from 'src/modules/admin/payment/components/PaymentStateCell'

export default {
  name: 'PaymentDisputeTable',
  components: {
    ModelTable,
    DisputeDialog
  },
  props: {
    transferId: {
      type: Number,
      required: false,
      default: null
    },
    sortBy: {
      type: String,
      required: false,
      default: 'createdAt'
    },
    descending: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      recompute: false,
      showAllSites: false
    }
  },
  computed: {
    paymentQuery () {
      if (this.transferId) {
        return {
          disputed: true,
          transferId: this.transferId,
          disputedState: 'lost',
          recomputeDisputes: this.recompute
        }
      } else {
        return {
          disputed: true,
          recomputeDisputes: this.recompute,
          siteId: this.showAllSites ? null : this.currentSite.id
        }
      }
    },
    columns () {
      const disputeColumns = [{ field: 'id' }]

      if (this.showAllSites) {
        disputeColumns.push({
          name: 'site',
          field: dispute => this.siteNameChipForDispute(dispute),
          component: 'chip'
        })
      }

      return disputeColumns.concat([
        { field: 'type', component: OrderItemTypeCell },
        { field: 'disputedState', component: PaymentDisputeStateCell },
        { name: 'paymentState', field: 'state', component: PaymentStateCell },
        { name: 'createdAt', field: row => row.createdAt.i18n('timestamp'), component: 'date-time' },
        { name: 'paidAt', field: row => row.paidAt ? row.paidAt.i18n('timestamp') : null, component: 'date-time' },
        { name: 'disputedDecidedAt', field: 'disputeDecidedAt', component: 'date-time' },
        { field: 'amount', component: 'money' },
        { field: 'stripeFee', component: 'money' },
        { name: 'disputedFeeTotal', field: payment => payment.amount + payment.disputeFee, component: 'money' },
        { field: 'indyFee', component: 'money' },
        { field: 'order', component: 'model', newTab: true },
        { field: 'registerStation', component: 'model' }
      ])
    }
  },
  async mounted () {
    // Changes this data prop to trigger a re-fetch with the `recomputeDisputes` flag. This fetch should happen
    // after the ModelTable's initial fetch completes. The goal is to first fetch and display previously computed records,
    // then immediately trigger a recompute fetch to display any updated records. Note that the API will ignore
    // the `recomputeDisputes` flag if the table is paginating past the first page or filtering with search terms.
    await this.payments.ensureLoaded()
    this.recompute = true
  },
  created () {
    _.extend(this, {
      OrderItemTypeCell,
      PaymentStateCell,
      PaymentDisputeStateCell
    })
  },
  methods: {
    handleRowClick (payment) {
      const summaryOnly = payment.order.siteId !== this.currentSite.id
      this.$refs.disputeDialog.show(payment.disputeId, summaryOnly, payment.order.siteName)
    },
    updateModel () {
      this.payments.fetch(true)
    },
    siteNameChipForDispute (dispute) {
      if (dispute.order.siteId !== this.currentSite.id) {
        return {
          label: dispute.order.siteName,
          color: 'warning',
          textColor: 'white'
        }
      } else {
        return {
          label: dispute.order.siteName,
          color: 'primary',
          textColor: 'white'
        }
      }
    }
  },
  configuration: ['currentSite'],
  models: {
    payments: {
      order: 'default',
      registerStation: 'default',
      variables () {
        return this.paymentQuery
      },
      immediate: false
    }
  }
}
</script>
